/** Strings of the accounting overview screens (statements, assets, cash, dashboard, settings). */
export const accOverviewEn = {
  accStatements: {
    title: "Statements",
    subtitle:
      "Balance sheet and income statement in the short form of decree 500/2002 Coll., computed from the journal.",
    year: "Year",
    closingProposal: "Closing proposal",
    notBalancedTitle: "The balance sheet doesn't add up",
    notBalancedBody:
      "Assets and liabilities differ by {{difference}} Kč. The error is in the posting — go through the journal before deriving anything from this.",
    assets: "Assets",
    assetsTotal: "Total assets",
    liabilities: "Liabilities",
    liabilitiesTotal: "Total liabilities",
    profitOrLoss: "Profit or loss",
    profitSummary: "Revenue {{revenue}} − expenses {{expenses}}",
    revenue: "Revenue",
    expenses: "Expenses",
    incomeTax: "Income tax {{year}}",
    incomeTaxHint:
      "A working paper, not a return. Accounting profit is not the tax base — what the law doesn't recognise goes back on top, and the depreciation series are swapped.",
    closingTitle: "Proposed closing entries for {{year}}",
    closingHint:
      "Hub only proposes them. Closing the books is a decision — a person posts it in the journal.",
    closingEmpty: "Nothing to transfer for this year.",
    fx: {
      title: "Exchange rate differences",
      hint: "What open foreign-currency documents are worth on the balance sheet date. The CNB rate of that day decides — Hub never invents one.",
      compute: "Compute",
      computeFailed: "Couldn't compute the revaluation.",
      postFailed: "Couldn't post it.",
      missingRates:
        "The CNB has no fixing for {{currencies}} on that day — pick the last banking day of the year.",
      summary: "Gains {{gain}} · losses {{loss}}",
      posted: " · posted as entry no. {{number}}",
      none: "Nothing open in a foreign currency on that date.",
      document: "Document",
      partner: "Partner",
      outstanding: "Outstanding",
      rate: "Rate then → now",
      difference: "Difference",
      posting: "Posting…",
      post: "Post the difference",
    },
  },
  accAssets: {
    title: "Assets",
    subtitle_one:
      "Net book value {{value}} Kč across {{count}} card. Monthly accounting depreciation posts itself; the button is only to catch up after an outage.",
    subtitle_few:
      "Net book value {{value}} Kč across {{count}} cards. Monthly accounting depreciation posts itself; the button is only to catch up after an outage.",
    subtitle_other:
      "Net book value {{value}} Kč across {{count}} cards. Monthly accounting depreciation posts itself; the button is only to catch up after an outage.",
    posting: "Posting…",
    postLastMonth: "Post last month",
    close: "Close",
    newCard: "New card",
    depreciateFailed: "Couldn't post the depreciation.",
    cards: "Cards",
    cardsHint: "Disposed assets stay in the list — they are evidence.",
    noCards: "No cards yet.",
    number: "Number",
    name: "Name",
    inUseSince: "In use since",
    group: "Group",
    cost: "Cost",
    depreciated: "Depreciated",
    netValue: "Net value",
    disposed: "disposed",
    schedule: "Schedule",
    method: {
      straight_line: "straight line",
      accelerated: "accelerated",
    },
    scheduleFailed: "Couldn't load the schedule.",
    taxDepreciation: "Tax depreciation",
    taxDepreciationHint: "Under the Income Tax Act — this goes into the income tax return.",
    accDepreciation: "Accounting depreciation",
    accDepreciationHint: "Monthly, over the time the asset really serves.",
    form: {
      title: "New asset card",
      createFailed: "Couldn't create the card.",
      cardNumber: "Card number",
      name: "Name",
      cost: "Cost",
      acquired: "Acquired",
      inUseSince: "In use since",
      accMonths: "Accounting depreciation (months)",
      group: "Depreciation group",
      groupN: "Group {{group}}",
      taxMethod: "Tax method",
      creating: "Creating…",
      create: "Create",
    },
  },
  accCash: {
    title: "Cash desk",
    subtitle:
      "The balance is entered once — at the migration or after a stocktake. From then on the documents compute it.",
    createRegisterFailed: "Couldn't create the register.",
    noRegister: "No cash register yet.",
    openingLine: "Opening balance {{amount}} as of ",
    documents_one: "{{count}} document",
    documents_few: "{{count}} documents",
    documents_other: "{{count}} documents",
    inOut: "in {{income}} · out {{expense}}",
    hideBook: "Hide the book",
    cashBook: "Cash book",
    newRegister: "New cash register",
    newRegisterHint:
      "Enter the opening balance as it really was on that day — everything else is computed from it.",
    name: "Name",
    namePlaceholder: "Main register",
    currency: "Currency",
    openingBalance: "Opening balance",
    asOfDate: "As of",
    creating: "Creating…",
    createRegister: "Create register",
    issueFailed: "Couldn't issue the document.",
    type: "Type",
    receipt: "Receipt",
    payment: "Payment",
    date: "Date",
    amount: "Amount",
    purpose: "Purpose",
    purposePlaceholder: "Office supplies",
    issuing: "Issuing…",
    issue: "Issue",
    loading: "Loading…",
    colDocument: "Document",
    colDate: "Date",
    colPurpose: "Purpose",
    colIn: "In",
    colOut: "Out",
    colBalance: "Balance",
  },
  accIndex: {
    title: "Overview",
    subtitle: "The last twelve months by issue date, and what is still open on either side.",
    leavingFakturoid: "Leaving Fakturoid",
    newInvoiceFromReport: "New invoice from a report",
    incomeAndExpenses: "Income and expenses",
    income: "Income",
    expenses: "Expenses",
    difference: "Difference",
    invoices: "Invoices",
    allInvoices: "All invoices",
    allExpenses: "All expenses",
    unpaid: "Unpaid ({{count}})",
    overdue: "Overdue ({{count}})",
    bankThisMonth: "Bank this month",
    in: "In",
    out: "Out",
    lastMovement: "Last movement:",
    nothingImported: "nothing imported yet",
    bank: "Bank",
    cash: "Cash",
    registers_one: "{{count}} register, balance from the documents",
    registers_few: "{{count}} registers, balance from the documents",
    registers_other: "{{count}} registers, balance from the documents",
    cashBook: "Cash book",
    waiting: "Waiting for you",
    unmatchedPayments: "unmatched payments",
    inboxDocuments: "documents in the inbox",
    invoicesOverdue: "invoices overdue",
    withoutPdf: "imported documents without a PDF",
    tidy: "Nothing — the books are tidy.",
    latestInvoices: "Latest invoices",
    seeAll: "See all",
    nothingIssued: "Nothing issued yet.",
    status: {
      paid: "paid",
      partially_paid: "partially paid",
      issued: "issued",
      draft: "draft",
      cancelled: "cancelled",
    },
  },
  accSettings: {
    title: "Accounting settings",
    subtitle:
      "What every document we issue says about us. A document already issued keeps the values it was issued with — changing these only affects new ones.",
    saveFailed: "Couldn't save the settings.",
    importFailed: "Couldn't read the Fakturoid account.",
    reading: "Reading…",
    importFromFakturoid: "Import from Fakturoid",
    company: "Company",
    companyHint: "Issued documents carry these details.",
    companyEmptyHint:
      "Nothing is set up yet — Hub cannot issue a document until it knows who is issuing it.",
    companyName: "Company name",
    registrationNo: "Registration no.",
    vatNo: "VAT no.",
    street: "Street",
    zip: "ZIP",
    city: "City",
    country: "Country",
    bankAccount: "Bank account",
    iban: "IBAN",
    swiftBic: "SWIFT / BIC",
    vatPayer: "VAT payer",
    standardVatRate: "Standard VAT rate (%)",
    dueDays: "Due in (days)",
    invoiceEmail: "Invoicing e-mail",
    invoiceNote: "Note on the invoice",
    taxFiler: "VAT return preparer",
    taxFilerHint:
      "Printed in the VetaP of every VAT return and control statement. Until you save, the values of the last filed return are used.",
    taxFilerFailed: "Couldn't save the preparer.",
    preparerFirstName: "Prepared by: first name",
    preparerLastName: "Prepared by: last name",
    preparerPhone: "Prepared by: phone",
    signatoryFirstName: "Authorised person: first name",
    signatoryLastName: "Authorised person: last name",
    signatoryPosition: "Authorised person: position",
    nace: "Main activity (CZ-NACE, up to 6 digits)",
    saving: "Saving…",
    save: "Save",
    numberSeries: "Number series",
    numberSeriesHint:
      "Each document type counts on its own, per year. A new year continues after the highest number already used — including the documents imported from Fakturoid.",
    noSeries: "No series yet — one is created when the first document of a type is issued.",
    type: "Type",
    year: "Year",
    format: "Format",
    lastNumber: "Last number",
  },
};

export const accOverviewCs: typeof accOverviewEn = {
  accStatements: {
    title: "Výkazy",
    subtitle:
      "Rozvaha a výkaz zisku a ztráty ve zkráceném rozsahu podle vyhlášky č. 500/2002 Sb., sestavené z účetního deníku.",
    year: "Rok",
    closingProposal: "Návrh uzávěrky",
    notBalancedTitle: "Rozvaha nesedí",
    notBalancedBody:
      "Aktiva a pasiva se liší o {{difference}} Kč. Chyba je v zaúčtování — projděte deník, než z tohoto budete cokoliv odvozovat.",
    assets: "Aktiva",
    assetsTotal: "Aktiva celkem",
    liabilities: "Pasiva",
    liabilitiesTotal: "Pasiva celkem",
    profitOrLoss: "Zisk nebo ztráta",
    profitSummary: "Výnosy {{revenue}} − náklady {{expenses}}",
    revenue: "Výnosy",
    expenses: "Náklady",
    incomeTax: "Daň z příjmů {{year}}",
    incomeTaxHint:
      "Pracovní podklad, ne přiznání. Účetní zisk není základ daně — co zákon neuznává, se připočítá zpět a řady odpisů se zamění.",
    closingTitle: "Navržené uzávěrkové zápisy za rok {{year}}",
    closingHint:
      "Hub je jen navrhuje. Uzavření účetnictví je rozhodnutí — zaúčtuje ho člověk v deníku.",
    closingEmpty: "Za tento rok není co převádět.",
    fx: {
      title: "Kurzové rozdíly",
      hint: "Kolik jsou k rozvahovému dni hodny otevřené doklady v cizí měně. Rozhoduje kurz ČNB k tomuto dni — Hub si žádný nevymýšlí.",
      compute: "Spočítat",
      computeFailed: "Přecenění se nepodařilo spočítat.",
      postFailed: "Nepodařilo se zaúčtovat.",
      missingRates:
        "ČNB k tomuto dni nemá kurz pro {{currencies}} — zvolte poslední bankovní den roku.",
      summary: "Kurzové zisky {{gain}} · ztráty {{loss}}",
      posted: " · zaúčtováno jako zápis č. {{number}}",
      none: "K tomuto datu nic nezbývá uhradit v cizí měně.",
      document: "Doklad",
      partner: "Partner",
      outstanding: "Zbývá uhradit",
      rate: "Kurz tehdy → nyní",
      difference: "Rozdíl",
      posting: "Účtuji…",
      post: "Zaúčtovat rozdíl",
    },
  },
  accAssets: {
    title: "Majetek",
    subtitle_one:
      "Zůstatková cena {{value}} Kč na {{count}} kartě. Měsíční účetní odpisy se zaúčtují samy; tlačítko slouží jen k doplnění po výpadku.",
    subtitle_few:
      "Zůstatková cena {{value}} Kč na {{count}} kartách. Měsíční účetní odpisy se zaúčtují samy; tlačítko slouží jen k doplnění po výpadku.",
    subtitle_other:
      "Zůstatková cena {{value}} Kč na {{count}} kartách. Měsíční účetní odpisy se zaúčtují samy; tlačítko slouží jen k doplnění po výpadku.",
    posting: "Účtuji…",
    postLastMonth: "Zaúčtovat minulý měsíc",
    close: "Zavřít",
    newCard: "Nová karta",
    depreciateFailed: "Odpisy se nepodařilo zaúčtovat.",
    cards: "Karty",
    cardsHint: "Vyřazený majetek zůstává v seznamu — je to doklad.",
    noCards: "Zatím žádné karty.",
    number: "Číslo",
    name: "Název",
    inUseSince: "V užívání od",
    group: "Skupina",
    cost: "Pořizovací cena",
    depreciated: "Odepsáno",
    netValue: "Zůstatková cena",
    disposed: "vyřazeno",
    schedule: "Odpisy",
    method: {
      straight_line: "rovnoměrné",
      accelerated: "zrychlené",
    },
    scheduleFailed: "Odpisový plán se nepodařilo načíst.",
    taxDepreciation: "Daňové odpisy",
    taxDepreciationHint: "Podle zákona o daních z příjmů — jdou do přiznání k dani z příjmů.",
    accDepreciation: "Účetní odpisy",
    accDepreciationHint: "Měsíčně, po dobu, po kterou majetek skutečně slouží.",
    form: {
      title: "Nová karta majetku",
      createFailed: "Kartu se nepodařilo vytvořit.",
      cardNumber: "Číslo karty",
      name: "Název",
      cost: "Pořizovací cena",
      acquired: "Pořízeno",
      inUseSince: "V užívání od",
      accMonths: "Účetní odpisování (měsíce)",
      group: "Odpisová skupina",
      groupN: "Skupina {{group}}",
      taxMethod: "Daňová metoda",
      creating: "Vytvářím…",
      create: "Vytvořit",
    },
  },
  accCash: {
    title: "Pokladna",
    subtitle: "Zůstatek se zadává jednou — při migraci nebo po inventuře. Dál ho počítají doklady.",
    createRegisterFailed: "Pokladnu se nepodařilo vytvořit.",
    noRegister: "Zatím žádná pokladna.",
    openingLine: "Počáteční stav {{amount}} k ",
    documents_one: "{{count}} doklad",
    documents_few: "{{count}} doklady",
    documents_other: "{{count}} dokladů",
    inOut: "příjem {{income}} · výdej {{expense}}",
    hideBook: "Skrýt knihu",
    cashBook: "Pokladní kniha",
    newRegister: "Nová pokladna",
    newRegisterHint:
      "Zadejte počáteční stav tak, jak skutečně byl v ten den — vše ostatní se z něj dopočítá.",
    name: "Název",
    namePlaceholder: "Hlavní pokladna",
    currency: "Měna",
    openingBalance: "Počáteční stav",
    asOfDate: "K datu",
    creating: "Vytvářím…",
    createRegister: "Vytvořit pokladnu",
    issueFailed: "Doklad se nepodařilo vystavit.",
    type: "Typ",
    receipt: "Příjem",
    payment: "Výdej",
    date: "Datum",
    amount: "Částka",
    purpose: "Účel",
    purposePlaceholder: "Kancelářské potřeby",
    issuing: "Vystavuji…",
    issue: "Vystavit",
    loading: "Načítám…",
    colDocument: "Doklad",
    colDate: "Datum",
    colPurpose: "Účel",
    colIn: "Příjem",
    colOut: "Výdej",
    colBalance: "Zůstatek",
  },
  accIndex: {
    title: "Přehled",
    subtitle:
      "Posledních dvanáct měsíců podle data vystavení a co zůstává otevřené na obou stranách.",
    leavingFakturoid: "Odchod z Fakturoidu",
    newInvoiceFromReport: "Nová faktura z výkazu",
    incomeAndExpenses: "Příjmy a výdaje",
    income: "Příjmy",
    expenses: "Výdaje",
    difference: "Rozdíl",
    invoices: "Faktury",
    allInvoices: "Všechny faktury",
    allExpenses: "Všechny výdaje",
    unpaid: "Neuhrazené ({{count}})",
    overdue: "Po splatnosti ({{count}})",
    bankThisMonth: "Banka tento měsíc",
    in: "Příchozí",
    out: "Odchozí",
    lastMovement: "Poslední pohyb:",
    nothingImported: "zatím nic naimportováno",
    bank: "Banka",
    cash: "Pokladna",
    registers_one: "{{count}} pokladna, zůstatek z dokladů",
    registers_few: "{{count}} pokladny, zůstatek z dokladů",
    registers_other: "{{count}} pokladen, zůstatek z dokladů",
    cashBook: "Pokladní kniha",
    waiting: "Čeká na vás",
    unmatchedPayments: "nespárovaných plateb",
    inboxDocuments: "dokladů ve schránce",
    invoicesOverdue: "faktur po splatnosti",
    withoutPdf: "importovaných dokladů bez PDF",
    tidy: "Nic — účetnictví je v pořádku.",
    latestInvoices: "Poslední faktury",
    seeAll: "Zobrazit vše",
    nothingIssued: "Zatím nic nevystaveno.",
    status: {
      paid: "uhrazeno",
      partially_paid: "částečně uhrazeno",
      issued: "vystaveno",
      draft: "koncept",
      cancelled: "zrušeno",
    },
  },
  accSettings: {
    title: "Nastavení účetnictví",
    subtitle:
      "Co o nás uvádí každý vystavený doklad. Už vystavený doklad si ponechává hodnoty, se kterými vznikl — změna se týká jen nových.",
    saveFailed: "Nastavení se nepodařilo uložit.",
    importFailed: "Účet Fakturoidu se nepodařilo načíst.",
    reading: "Načítám…",
    importFromFakturoid: "Importovat z Fakturoidu",
    company: "Firma",
    companyHint: "Vystavené doklady obsahují tyto údaje.",
    companyEmptyHint:
      "Zatím není nic nastaveno — Hub nemůže vystavit doklad, dokud neví, kdo ho vystavuje.",
    companyName: "Název firmy",
    registrationNo: "IČO",
    vatNo: "DIČ",
    street: "Ulice",
    zip: "PSČ",
    city: "Město",
    country: "Země",
    bankAccount: "Bankovní účet",
    iban: "IBAN",
    swiftBic: "SWIFT / BIC",
    vatPayer: "Plátce DPH",
    standardVatRate: "Základní sazba DPH (%)",
    dueDays: "Splatnost (dny)",
    invoiceEmail: "E-mail pro fakturaci",
    invoiceNote: "Poznámka na faktuře",
    taxFiler: "Sestavovatel přiznání k DPH",
    taxFilerHint:
      "Uvádí se ve VetaP každého přiznání k DPH a kontrolního hlášení. Dokud nic neuložíte, použijí se hodnoty z posledního podaného přiznání.",
    taxFilerFailed: "Sestavovatele se nepodařilo uložit.",
    preparerFirstName: "Sestavil: jméno",
    preparerLastName: "Sestavil: příjmení",
    preparerPhone: "Sestavil: telefon",
    signatoryFirstName: "Oprávněná osoba: jméno",
    signatoryLastName: "Oprávněná osoba: příjmení",
    signatoryPosition: "Oprávněná osoba: postavení",
    nace: "Převažující činnost (CZ-NACE, nejvýše 6 číslic)",
    saving: "Ukládám…",
    save: "Uložit",
    numberSeries: "Číselné řady",
    numberSeriesHint:
      "Každý typ dokladu se počítá zvlášť, po rocích. Nový rok navazuje za nejvyšším už použitým číslem — včetně dokladů importovaných z Fakturoidu.",
    noSeries: "Zatím žádné řady — vytvoří se při vystavení prvního dokladu daného typu.",
    type: "Typ",
    year: "Rok",
    format: "Formát",
    lastNumber: "Poslední číslo",
  },
};
